import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-schedule-shift-confirmation',
  templateUrl: './schedule-shift-confirmation.component.html',
  styleUrls: ['./schedule-shift-confirmation.component.scss']
})
export class ScheduleShiftConfirmationComponent {
  public confirmVal!:string| number;
  constructor(private dialogRef:MatDialogRef<ScheduleShiftConfirmationComponent>){}
  onCancel(){
   this.dialogRef.close();
  } 
  onSubmit(){
   this.dialogRef.close({data:this.confirmVal})
  }
}
